import React from 'react';
import { Tag } from 'antd';
import { asserts } from '../../../utils';
import './index.less';

const { isFunction } = asserts;
const { CheckableTag } = Tag;

export default ({ className, dataSource, value, onChange }) => {
  const [selectedValue, setSelectedValue] = React.useState(value);
  React.useEffect(() => {
    setSelectedValue(value);
  }, [dataSource, value]);
  const handleChange = (item, checked) => {
    if (checked) {
      setSelectedValue(item.lgsCode);
    } else {
      setSelectedValue('');
    }
    isFunction(onChange) && onChange(checked ? item : undefined);
  };
  return (
    <div className="divider-container">
      {dataSource.map((item, index) => {
        const { lgsCode, applicable, enable } = item || {};
        return (
          <CheckableTag
            key={index}
            checked={lgsCode === selectedValue}
            className={`pointer ${className}`}
            style={{
              display: applicable && `${enable}` === '1' ? 'inline-block' : 'none',
              color: '#000',
            }}
            onChange={(checked) => handleChange(item, checked)}
          >
            {/* <img src={`${process.env.ASSETS}/${item && item.logoUrl}`} alt="加载中..." /> */}
            <span
              style={{
                textAlign: 'center',
                display: 'block',
                height: '34px',
                lineHeight: '34px',
                fontSize: '14px',
              }}
            >
              {item.lgsName}
            </span>
          </CheckableTag>
        );
      })}
    </div>
  );
};
